import styles from "./style.module.css";
import ResultImg from "./Result.svg";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import mainContext from "../../../context/mainContext";
import Button from "../../../components/Common/Button";
import RatingAndScore from "../../../components/Common/ReatingAndScore";
import tfSrc from "./TrainFocusResultIcon.png"
// Creator : Team A - Efart

function Result({ children, from, submit: { path, name, onClick = () => { } } = {} }) {
   const { state } = useLocation()
   const navigate = useNavigate()
   const { header: { setPageName, setIsShowHeader } } = useContext(mainContext)

   useEffect(() => {
      //TODO: yos handle with header layout in all pages
      if (from === "train-focus") {
         setIsShowHeader(true)
         setPageName("NEAR-POINT RESULTS");
      } else if (from == "assessments") {
         setIsShowHeader(true)
         setPageName("WEEKLY MEASUREMENT RESULTS");

         // setPageName("");
      }
      return () => setPageName("")
   }, [])


   // TODO - print result from the state
   // there few options to that page



   return (
      <div className={`${styles.result} ${from === "assessments" ? styles.resultASS : from == "train-focus" ? styles.result : 'pages'}`} style={(window.buildType === "iPhone" && from === "assessments") ? { paddingTop: "0", minHeight: "80vh" } : { paddingTop: "0" }}>
         <img src={ResultImg} alt="result" className={styles.img} />
         {from === "assessments" && <RatingAndScore wpm={Math.round(state.AVG)} std={Math.round(state.STD)} compScore={state.count} />}
         {from === "train-focus" && <div className={`result--div two-colored-div`} >
            <div className="twistBoxChildren">
               <img src={tfSrc} alt="FrameBookTime" />
               <span>NEAR-POINT DISTANCE</span>
               <span>{Math.floor(state.comfortDistance) || -1} CM</span>
            </div>
         </div>
         }
         <div className={styles.btnHolder}>
            <Button title="Go to Dashboard" startFunction={() => navigate("/")} />
         </div>
      </div>
   );
}

export default Result;